import React from "react";
import { FileCheck2Icon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { clinicalTools } from "../data/content";
export function ClinicalTools() {
  return <section className="bg-brand-50 px-5 py-16 md:px-8 md:py-24" data-id="element-86" data-mp="350julfcs72yc">
      <div className="mx-auto max-w-4xl" data-id="element-87" data-mp="34yp5rpye2qoz">
        <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-88" data-mp="30zq2saw7x406">
          Practical tools you can use during your clinical workflow
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-muted" data-id="element-89" data-mp="2r0r67qoq8ytj">
          Your collection also includes decision-support resources designed for real-world professional use.
        </p>

        <ul className="mt-10 divide-y divide-brand-200 rounded-3xl bg-white px-6 md:px-8" data-id="element-90" data-mp="2i144f3s35qzy">
          {clinicalTools.map(t => <li key={t.name} className="flex items-start gap-4 py-5" data-id="element-91" data-mp="ka17ty1dullx">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-brand-700" data-id="element-92" data-mp="g8plq2hpwiih">
                <FileCheck2Icon className="h-5 w-5" aria-hidden="true" data-id="element-93" data-mp="1u4n7ia881mmk" />
              </span>
              <div data-id="element-94" data-mp="1z648s6umbb3o">
                <h3 className="text-lg font-bold text-ink" data-id="element-95" data-mp="1z387c8jka4ah">{t.name}</h3>
                <p className="mt-1 text-base text-muted" data-id="element-96" data-mp="1l6v0rugkfnas">{t.body}</p>
              </div>
            </li>)}
        </ul>

        <h3 className="mt-12 text-center text-2xl font-extrabold text-brand-900 md:text-3xl" data-id="element-97" data-mp="1p97utlly9wrq">
          Stop rebuilding your assessment process from scratch.
        </h3>
        <SectionCTA label="Get all 6 clinical volumes for $27" data-id="element-98" data-mp="2huhjkpkpv75r" />
      </div>
    </section>;
}